import * as Enums from '@/enums.ts';

export const presetThemes = [
    {
        themeName: 'Default',
        primaryColor: [50, 50, 55],
        accentColor: [84, 110, 122],
        fontColorOnPrimary: [255, 255, 255],
        fontColorOnAccent: [255, 255, 255],
        primaryFont: 'Roboto',
        primaryFontVariant: 'regular',
        primaryFontScale: 1,
        secondaryFont: 'Oswald',
        secondaryFontVariant: 'regular',
        secondaryFontScale: 1,
        secondaryFontUppercase: true,
        priceDisplayFormat: Enums.ePriceDisplayFormats.minDecimal,
    },
    {
        themeName: 'Classy',
        primaryColor: [245, 240, 235],
        accentColor: [245, 240, 235],
        fontColorOnPrimary: [55, 55, 55],
        fontColorOnAccent: [55, 55, 55],
        primaryFont: 'Poppins',
        primaryFontVariant: 'regular',
        primaryFontScale: 1,
        secondaryFont: 'Poppins',
        secondaryFontVariant: 'regular',
        secondaryFontScale: 0.9,
        secondaryFontUppercase: true,
        priceDisplayFormat: Enums.ePriceDisplayFormats.minDecimal,
    },
    {
        themeName: 'Nouvelle Blanc',
        primaryColor: [255, 255, 255],
        accentColor: [255, 255, 255],
        fontColorOnPrimary: [40, 40, 40],
        fontColorOnAccent: [40, 40, 40],
        primaryFont: 'Quicksand',
        primaryFontVariant: '500',
        primaryFontScale: 1,
        secondaryFont: 'Raleway',
        secondaryFontVariant: '600',
        secondaryFontScale: 0.8,
        secondaryFontUppercase: true,
        priceDisplayFormat: Enums.ePriceDisplayFormats.minDecimal,
    },
    {
        themeName: 'Nouvelle Noir',
        primaryColor: [15, 15, 15],
        accentColor: [15, 15, 15],
        fontColorOnPrimary: [255, 255, 255],
        fontColorOnAccent: [255, 255, 255],
        primaryFont: 'Quicksand',
        primaryFontVariant: 'regular',
        primaryFontScale: 1,
        secondaryFont: 'Poppins',
        secondaryFontVariant: 'regular',
        secondaryFontScale: 0.9,
        secondaryFontUppercase: false,
        priceDisplayFormat: Enums.ePriceDisplayFormats.minDecimal,
    },
    {
        themeName: 'Cyberpunk',
        primaryColor: [0, 0, 0],
        accentColor: [0, 45, 45],
        fontColorOnPrimary: [180, 255, 255],
        fontColorOnAccent: [180, 255, 255],
        primaryFont: 'Roboto',
        primaryFontVariant: 'regular',
        primaryFontScale: 1,
        secondaryFont: 'Roboto Condensed',
        secondaryFontVariant: '300',
        secondaryFontScale: 1,
        secondaryFontUppercase: true,
        priceDisplayFormat: Enums.ePriceDisplayFormats.minDecimal,
    },
    {
        themeName: 'Healthy',
        primaryColor: [255, 255, 255],
        accentColor: [88, 166, 88],
        fontColorOnPrimary: [64, 64, 64],
        fontColorOnAccent: [255, 255, 255],
        primaryFont: 'Quicksand',
        primaryFontVariant: '500',
        primaryFontScale: 1,
        secondaryFont: 'Economica',
        secondaryFontVariant: 'regular',
        secondaryFontScale: 1.2,
        secondaryFontUppercase: true,
        priceDisplayFormat: Enums.ePriceDisplayFormats.minDecimal,
    },
    {
        themeName: 'Caribbean',
        primaryColor: [250, 244, 225],
        accentColor: [91, 154, 218],
        fontColorOnPrimary: [0, 0, 0],
        fontColorOnAccent: [255, 255, 255],
        primaryFont: 'Quicksand',
        primaryFontVariant: '500',
        primaryFontScale: 1,
        secondaryFont: 'Poppins',
        secondaryFontVariant: 'regular',
        secondaryFontScale: 0.9,
        secondaryFontUppercase: true,
        priceDisplayFormat: Enums.ePriceDisplayFormats.minDecimal,
    },
    {
        themeName: 'Fresh',
        primaryColor: [255, 255, 255],
        accentColor: [88, 146, 132],
        fontColorOnPrimary: [0, 0, 0],
        fontColorOnAccent: [255, 255, 255],
        primaryFont: 'Quicksand',
        primaryFontVariant: '500',
        primaryFontScale: 1,
        secondaryFont: 'Oswald',
        secondaryFontVariant: 'regular',
        secondaryFontScale: 1,
        secondaryFontUppercase: true,
        priceDisplayFormat: Enums.ePriceDisplayFormats.minDecimal,
    },
];
